// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"54":"8d2150","98":"f540dc","272":"7537cd","308":"959af1","527":"25a164","532":"f0ccab","626":"5a120a","981":"98473c"}[chunkId] + ".js";
};